<template>
  <div>
    <h1>Projektdetails</h1>
    <h3 v-if="dataLoaded">{{project.title}}</h3>
    <h3 v-else>...</h3>
    <table class="table">
      <tr>
        <td v-for="dataRange in dataRanges">          
          <router-link :to="{ path: '/users/userHoursDateRange', query: { from: dataRange.from, to: dataRange.to, projectId: projectId }}" class="btn btn-info">{{dataRange.title}}</router-link>
        </td>
      </tr>
      <tr>
        <td v-for="dataRange in dataRanges">
          <table>
            <tr v-if="dataRange.userDataLoaded" v-for="(userHour, index) in dataRange.userHours" :key="userHour.userId">
              <td>{{userHour.userName}}</td>
              <!--TODO: Use real end of month-->
              <td><router-link :to="{ path: '/users/userHoursDateRange', query: { from: dataRange.from, to: dataRange.to, projectId: projectId, userId: userHour.userId }}" class="btn btn-info">{{userHour.hours | hour}}</router-link></td>
            </tr>
            <tr v-else>...</tr>
          </table>
        </td>
      </tr>

      <!--<tr v-if="userDataLoaded" v-for="(userHour, index) in userHours" :key="userHour.userId">
        <td>{{userHour.userName}}</td>-->
      <!--TODO: Use real end of month-->
      <!--<td>{{userHour.hours | hour}}</td>
      </tr>-->
      <!--<tr v-else>...</tr>-->
    </table>
  </div>
</template>

<style>
  .home {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
</style>

<script>
  import axios from "axios";
  import moment from "moment";


  export default {
    components: {
    },
    name: "projectDetails",
    data() {
      return {
        projectId: "",
        project: null,
        dataLoaded: false,
        dataRanges: []
      };
    },
    methods: {
      getProjectData: function (dataRangeIndex) {
        var dataRange = this.dataRanges[dataRangeIndex];
        axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "projects/GetUserProjectHours?projectid=" + this.projectId + "&from=" + dataRange.from + "&to=" + dataRange.to }).then(result => {
          this.dataRanges[dataRangeIndex].userHours = result.data;
          this.dataRanges[dataRangeIndex].userDataLoaded = true;
        }, error => {
          console.error(error);
          this.dataRanges[dataRangeIndex].userDataLoaded = false;
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        });
      }
    },
    mounted() {
      this.dataRanges.push({
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().endOf('month').format('YYYY-MM-DD'),
        userHours: [],
        userDataLoaded: false,
        title: "Dieser Monat"
      });
      this.dataRanges.push({
        from: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        to: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
        userHours: [],
        userDataLoaded: false,
        title: "Letzter Monat"
      });
      this.dataRanges.push({
        from: moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'),
        to: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
        userHours: [],
        userDataLoaded: false,
        title: "Letzte 3 Monate"
      });
      this.dataRanges.push({
        from: moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD'),
        to: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
        userHours: [],
        userDataLoaded: false,
        title: "Letzte 6 Monate"
      });
      this.dataRanges.push({
        from: "2000-1-1",
        to: "2100-1-1",
        userHours: [],
        userDataLoaded: false,
        title: "Alle Stunden"
      });
      //Load users
      this.projectId = this.$route.query.projectId;

      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "projects/" + this.projectId }).then(result => {
        this.project = result.data;
        this.dataLoaded = true;
      }, error => {
        console.error(error);
        this.dataLoaded = false;
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });
      for (var i = 0; i < this.dataRanges.length; i++) {
        this.getProjectData(i);
      }
    }
  };


</script>
